'use strict'
import configApp from './configApp'
import router from './router'
const cfg = {
  router: {
    routes: [...router]
  }
}
configApp(cfg)
